<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary" v-if="!disabled">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <j-vxe-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :height="400"
        :loading="loading"
        @valueChange="handleValueChange"
        drag-sort
        keep-source
        ref="vTable"
        row-number
        row-selection
        style="margin-top: 8px;"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <!-- <span slot="action" slot-scope="text, record">
          <a-divider type="vertical" />
          <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
            <a>删除</a>
          </a-popconfirm>

        </span>-->

        <template v-if="!disabled" v-slot:action="props">
          <a-button @click="handleDelete(props)" icon="delete" size="small" type="danger">删除</a-button>
          <!-- <a @click="handleDelete(props)">删除</a> -->
        </template>
      </j-vxe-table>
    </div>

    <dev-bpbj-warehousing-list-modal @ok="modalFormOk" ref="modalForm"></dev-bpbj-warehousing-list-modal>
  </a-card>
</template>

<script>
  import { JVXETypes } from '@/components/jeecg/JVxeTable'

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevBpbjWarehousingListModal from './modules/DevBpbjWarehousingListModal'
  import { getAction } from '../../../api/manage'

  export default {
    name: 'DevBpbjWarehousingListList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevBpbjWarehousingListModal
    },
    props: {
      triggerId: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      tableData: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        description: '采购物资清单管理页面',
        ipagination_: {
          current: 1,
          pageSize: 200,
          pageSizeOptions: ['200'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        superQueryParams: {

        },
        // 表头
        columns: [

          {
            title: '备件名称',

            align: 'center',
            key: 'bjName'
          },

          {
            title: '单位',
            align: 'center',
            key: 'unit',
            defaultValue: ''
          }, {
            title: '采购数量',
            align: 'center',
            type: JVXETypes.input,

            key: 'purchaseNum',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ]
          },
          {
            title: '单价(元)',
            align: 'center',
            key: 'price',
            type: JVXETypes.input,

            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ]
          },
          {
            title: '总价(元)',
            align: 'center',
            key: 'cost'
          },
          // {
          //   title: '剩余个数',
          //   align: 'center',

          //   key: 'leftCount'
          // },


        ],
        url: {
          // list: '/spareparts/devBpbjWarehousingList/list',
          list: '/spareparts/devBpbjWarehousingList/list',
          delete: '/spareparts/devBpbjWarehousingList/delete',
          deleteBatch: '/spareparts/devBpbjWarehousingList/deleteBatch',
          exportXlsUrl: '/spareparts/devBpbjWarehousingList/exportXls',
          importExcelUrl: 'spareparts/devBpbjWarehousingList/importExcel',
          query: '/spareparts/devBpbjWarehousingRecord/queryDetailById'

        },
        disableMixinCreated: true,
        dictOptions: {},
        superFieldList: [],
        dataSource: [],
        editListIds: []
      }
    },
    created () {
      if (!this.disabled) {
        this.columns = this.columns.concat([{
          title: '操作',
          key: 'action',
          // width: '8%',
          width: '100px',
          type: JVXETypes.slot,
          slotName: 'action'
        }])
      }
      getAction(this.url.query + '?id=' + this.triggerId).then(res => {
        this.dataSource = res.result.list || []
        if (res.result.list !== null && res.result.list.length > 0) {
          this.editListIds = res.result.list.map(item => item.id)
        }
      })
    },

    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      handleValueChange (record) {
        const { rowIndex, row: { purchaseNum = 0, price = 0 } } = record
        const cost = purchaseNum * price
        this.dataSource[rowIndex].cost = cost
        const totalAmount = this.dataSource.reduce((pre, cur) => {
          return pre + (cur.cost ?? 0)
        }, 0)

        this.$emit('updateCount', totalAmount)
      },
      modalFormOk (v) {
        // 李浩待处理
        const that = this
        const list = v.reduce((pre, cur) => {
          const exitList = that.dataSource.find(item => (item.bjName + item.bjModel) == (cur.bjName + cur.bjModel) && item.bjCode == cur.bjCode)
          if (exitList && exitList.id) {
            pre.push(exitList)
          }
          return pre
        }, [])
        if (list.length > 0) {
          this.$message.error(list[0].bjName + ' 重复')
          return
        }
        const concatTableData = this.dataSource.concat(v)
        this.dataSource = concatTableData
        this.ipagination_.pageSize = this.dataSource.length
        this.ipagination_.total = this.dataSource.length
      },
      handleDelete (id) {
        const findId = this.dataSource.findIndex(item => item.id === id)
        this.dataSource.splice(findId, 1)
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'bjModelId', text: '备件型号ID(备件基本信息主键id)' })
        fieldList.push({ type: 'string', value: 'bjName', text: '备件名称' })
        fieldList.push({ type: 'number', value: 'purchaseNum', text: '采购数量' })
        fieldList.push({ type: 'string', value: 'unit', text: '单位' })
        fieldList.push({ type: 'number', value: 'price', text: '单价' })
        fieldList.push({ type: 'number', value: 'cost', text: '总价' })
        fieldList.push({ type: 'int', value: 'leftCount', text: '剩余个数' })
        fieldList.push({ type: 'string', value: 'whrId', text: '入库单ID' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      },
      handleTableCheck () {
        return new Promise((reslove, reject) => {
          this.$refs.vTable.validateTable().then(errMap => {
            // if (errMap) {
            //   reject(0)
            // } else {
            //   reslove(1)
            // }
            reslove(errMap ? 0 : 1)
          })
        })
        // const result = await this.$refs.vTable.validateTable()
        // return result
        // .then(errMap => {
        //   if (errMap) {
        //     console.log('表单验证未通过：', {errMap})
        //     this.$message.error('验证未通过，请在控制台查看详细')
        //   } else {
        //     this.$message.success('验证通过')
        //   }
        // })
      },

    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';
  .ant-form-item {
    margin-bottom: 0px;
  }

</style>
